export const searchIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.208 21.5C17.4547 21.5 21.708 17.2467 21.708 12C21.708 6.75329 17.4547 2.5 12.208 2.5C6.9613 2.5 2.70801 6.75329 2.70801 12C2.70801 17.2467 6.9613 21.5 12.208 21.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.708 22.5L20.708 20.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const filterIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M5.98486 2.09998H19.1849C20.2849 2.09998 21.1849 2.99998 21.1849 4.09998V6.29998C21.1849 7.09998 20.6849 8.09998 20.1849 8.59998L15.8849 12.4C15.2849 12.9 14.8849 13.9 14.8849 14.7V19C14.8849 19.6 14.4849 20.4 13.9849 20.7L12.5849 21.6C11.2849 22.4 9.48486 21.5 9.48486 19.9V14.6C9.48486 13.9 9.08486 13 8.68486 12.5L4.88486 8.49998C4.38486 7.99998 3.98486 7.09998 3.98486 6.49998V4.19998C3.98486 2.99998 4.88486 2.09998 5.98486 2.09998Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.515 2.09998L6.58496 9.99998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const exportIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M9.90479 6.5L12.4648 3.94L15.0248 6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4648 14.18V4.01001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58496 12C4.58496 16.42 7.58496 20 12.585 20C17.585 20 20.585 16.42 20.585 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const chevronLeft = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M12.586 16.6L7.15264 11.1667C6.51097 10.525 6.51097 9.47503 7.15264 8.83336L12.586 3.40002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const chevronRight = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M7.51074 16.6L12.9441 11.1667C13.5857 10.525 13.5857 9.47503 12.9441 8.83336L7.51074 3.40002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const copyIcon = (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
    <path
      d="M14.1311 14.4587H5.55243C4.691 14.4587 3.99268 13.8244 3.99268 13.042V5.25037C3.99268 4.46796 4.691 3.8337 5.55243 3.8337H8.67194V5.25037H5.55243V13.042H14.1311V10.2087H15.6908V13.042C15.6908 13.8244 14.9925 14.4587 14.1311 14.4587ZM9.99773 10.0012L8.8981 8.99958L13.8059 4.54203H11.0116V3.12537H16.4707V8.0837H14.911V5.54432L9.99773 10.0012Z"
      fill="currentColor"
    />
  </svg>
);
export const editIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M6.24264 15.9967H18V18H0V13.7504L9.8995 3.83471L14.1421 8.08426L6.24264 15.9967ZM11.3137 2.41817L13.435 0.29337C13.8256 -0.0977902 14.4587 -0.0977902 14.8492 0.29337L17.6777 3.12644C18.0682 3.5176 18.0682 4.15181 17.6777 4.54297L15.5563 6.66777L11.3137 2.41817Z"
      fill="currentColor"
      fillOpacity="0.36"
    />
  </svg>
);
export const userIcon = (
  <svg viewBox="0 0 448 512">
    <path
      fill="currentColor"
      d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    />
  </svg>
);
export const plusIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M13.5 5C13.5 4.44772 13.0523 4 12.5 4C11.9477 4 11.5 4.44772 11.5 5V11H5.5C4.94772 11 4.5 11.4477 4.5 12C4.5 12.5523 4.94772 13 5.5 13H11.5V19C11.5 19.5523 11.9477 20 12.5 20C13.0523 20 13.5 19.5523 13.5 19V13H19.5C20.0523 13 20.5 12.5523 20.5 12C20.5 11.4477 20.0523 11 19.5 11H13.5V5Z"
      fill="currentColor"
    />
  </svg>
);
export const attentIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6663 7.99998C14.6663 11.6819 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6819 1.33301 7.99998C1.33301 4.31808 4.31778 1.33331 7.99967 1.33331C11.6816 1.33331 14.6663 4.31808 14.6663 7.99998ZM7.99967 7.33331C8.36786 7.33331 8.66634 7.63179 8.66634 7.99998V11.3339C8.66634 11.7021 8.36786 12.0006 7.99967 12.0006C7.63148 12.0006 7.33301 11.7021 7.33301 11.3339V7.99998C7.33301 7.63179 7.63148 7.33331 7.99967 7.33331ZM7.99967 5.99998C8.36786 5.99998 8.66634 5.7015 8.66634 5.33331C8.66634 4.96512 8.36786 4.66665 7.99967 4.66665C7.63148 4.66665 7.33301 4.96512 7.33301 5.33331C7.33301 5.7015 7.63148 5.99998 7.99967 5.99998Z"
      fill="currentColor"
    />
  </svg>
);
export const faceIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.28669 3C4.46601 3 3 4.46601 3 6.28669V17.7133C3 19.534 4.46601 21 6.28669 21H12.4798V13.9631H10.6191V11.4296H12.4798V9.26512C12.4798 7.56457 13.5792 6.00319 16.1119 6.00319C17.1373 6.00319 17.8956 6.10163 17.8956 6.10163L17.8359 8.46751C17.8359 8.46751 17.0626 8.4602 16.2187 8.4602C15.3054 8.4602 15.159 8.881 15.159 9.57958V11.4296H17.9085L17.7887 13.9631H15.159V21H17.7133C19.534 21 21 19.534 21 17.7133V6.2867C21 4.46603 19.534 3.00002 17.7133 3.00002H6.28667L6.28669 3Z"
      fill="currentColor"
    />
  </svg>
);
export const telegaIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M13.1533 7.42231C11.5415 8.14081 8.31916 9.62966 3.48779 11.8874C2.70328 12.2222 2.29169 12.5496 2.25439 12.8696C2.19086 13.4118 2.82344 13.6251 3.68254 13.914C3.79994 13.954 3.92148 13.994 4.04579 14.0384C4.89245 14.3332 6.03055 14.6784 6.62169 14.6917C7.15897 14.7036 7.75841 14.4666 8.41999 13.9806C12.9337 10.7111 15.2637 9.0593 15.4102 9.02375C15.5137 8.99856 15.6574 8.96597 15.7541 9.0593C15.8507 9.15115 15.8411 9.32596 15.8314 9.37337C15.7679 9.65929 13.29 12.1318 12.0055 13.4118C11.605 13.8103 11.3219 14.0932 11.2638 14.1584C11.134 14.3021 11.0014 14.4399 10.8743 14.5717C10.0871 15.3836 9.49869 15.9939 10.9075 16.9894C11.5645 17.454 12.0939 17.8403 12.6184 18.223L12.6657 18.2576C13.2555 18.6887 13.8439 19.1183 14.6063 19.6545C14.7997 19.7908 14.9847 19.9316 15.1657 20.0694C15.8521 20.5953 16.4695 21.0664 17.2319 20.9923C17.6739 20.9478 18.1325 20.5019 18.3645 19.1701C18.9128 16.0206 19.9929 9.20004 20.2429 6.38827C20.2581 6.15481 20.2489 5.92027 20.2153 5.68903C20.1952 5.50227 20.1104 5.33042 19.9777 5.20756C19.7802 5.03423 19.4736 4.9972 19.3355 5.00016C18.7126 5.01201 17.7568 5.36904 13.1533 7.42231Z"
      fill="currentColor"
    />
  </svg>
);
export const chevronBottom = (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
    <path
      d="M1 1L7 7L13 1"
      stroke="#6F767E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const cancelIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.70711 8.29286C9.31658 7.90234 8.68342 7.90234 8.29289 8.29286C7.90237 8.68339 7.90237 9.31655 8.29289 9.70708L10.5858 12L8.29292 14.2929C7.9024 14.6834 7.9024 15.3166 8.29292 15.7071C8.68345 16.0976 9.31661 16.0976 9.70714 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0977 9.31658 16.0977 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29286Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="currentColor"
    />
  </svg>
);
export const downIcon = (
  <svg width="104" height="110" viewBox="0 0 104 110" fill="none">
    <path
      d="M0 98.25H103.5V109.75H0V98.25ZM57.5 64.7367L92.4088 29.8279L100.54 37.9596L51.75 86.75L2.95964 37.9596L11.0913 29.8279L46 64.7367V0.5H57.5V64.7367Z"
      fill="currentColor"
    />
  </svg>
);
export const refresh = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M24.7169 26.0899C22.3795 28.1108 19.3327 29.3334 16.0003 29.3334C8.63653 29.3334 2.66699 23.3638 2.66699 16C2.66699 8.63622 8.63653 2.66669 16.0003 2.66669C23.3641 2.66669 29.3337 8.63622 29.3337 16C29.3337 18.8482 28.4406 21.4878 26.9193 23.6542L22.667 16H26.667C26.667 10.109 21.8914 5.33335 16.0003 5.33335C10.1093 5.33335 5.33366 10.109 5.33366 16C5.33366 21.8911 10.1093 26.6667 16.0003 26.6667C18.8673 26.6667 21.4699 25.5356 23.3867 23.6955L24.7169 26.0899Z"
      fill="currentColor"
    />
  </svg>
);
export const eyeIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z"
      fill="currentColor"
    />
  </svg>
);
export const timeIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13 12V7H11V14H17V12H13Z"
      fill="currentColor"
    />
  </svg>
);
export const closeIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M5.5886 4.41073C5.26317 4.0853 4.73553 4.0853 4.41009 4.41073C4.08466 4.73617 4.08466 5.26381 4.41009 5.58925L8.82085 10L4.41012 14.4107C4.08468 14.7362 4.08468 15.2638 4.41012 15.5892C4.73555 15.9147 5.26319 15.9147 5.58863 15.5892L9.99936 11.1785L14.4101 15.5893C14.7355 15.9147 15.2632 15.9147 15.5886 15.5893C15.914 15.2638 15.914 14.7362 15.5886 14.4107L11.1779 10L15.5886 5.58925C15.9141 5.26381 15.9141 4.73617 15.5886 4.41074C15.2632 4.0853 14.7356 4.0853 14.4101 4.41074L9.99936 8.82149L5.5886 4.41073Z"
      fill="currentColor"
    />
  </svg>
);
export const logOutIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M17.1667 18H11.1667C10.4303 18 9.83333 17.403 9.83333 16.6667V14H11.1667V16.6667H17.1667V7.33333H11.1667V10H9.83333V7.33333C9.83333 6.59695 10.4303 6 11.1667 6H17.1667C17.903 6 18.5 6.59695 18.5 7.33333V16.6667C18.5 17.403 17.903 18 17.1667 18ZM12.5 14.6667V12.6667H6.5V11.3333H12.5V9.33333L15.8333 12L12.5 14.6667Z"
      fill="currentColor"
    />
  </svg>
);
export const walletIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.1712 14.6755H17.2845C15.8693 14.6755 14.7217 13.5279 14.7217 12.1117C14.7217 10.6964 15.8693 9.54883 17.2845 9.54883H21.1407"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7214 12.0533H17.4243"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.60547 8.14318H11.6655"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.71387 12.2529C2.71387 5.84815 5.03863 3.71387 12.0148 3.71387C18.9901 3.71387 21.3148 5.84815 21.3148 12.2529C21.3148 18.6567 18.9901 20.792 12.0148 20.792C5.03863 20.792 2.71387 18.6567 2.71387 12.2529Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const dashIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M7.24512 14.7815L10.2383 10.8914L13.6524 13.5733L16.5815 9.79297"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="19.9954"
      cy="4.20052"
      r="1.9222"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9248 3.12012H7.65704C4.6456 3.12012 2.77832 5.25284 2.77832 8.26428V16.3467C2.77832 19.3581 4.60898 21.4817 7.65704 21.4817H16.2612C19.2726 21.4817 21.1399 19.3581 21.1399 16.3467V9.30776"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const linkedinIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.7324 0H2.26758C1.013 0 0 1.013 0 2.26758V21.7324C0 22.987 1.013 24 2.26758 24H21.7324C22.987 24 24 22.987 24 21.7324V2.26758C24 1.013 22.987 0 21.7324 0ZM7.34991 19.2959H3.09839V9.54113H7.34991V19.2959ZM5.22415 8.01466H5.17319C4.09106 8.01466 3.29871 7.22231 3.29871 6.14018C3.29871 5.05805 4.09106 4.26569 5.17319 4.26569C6.25531 4.26569 7.04767 5.05805 7.04767 6.14018C7.04767 7.22231 6.25531 8.01466 5.17319 8.01466ZM19.2959 19.2959H15.0444V14.9462C15.0444 13.4759 15.0266 11.9254 13.3215 11.9254C11.6199 11.9254 11.4517 13.3261 11.4517 14.8793V19.2959H7.20018V9.54113H11.3442V10.7713H11.3837C11.8104 10.0456 12.5311 9.24107 13.6992 9.24107C15.872 9.24107 16.8056 10.7109 16.8056 13.5525V19.2959H19.2959V19.2959Z"
      fill="#6F767E"
    />
  </svg>
);
